const API_BASE = "/api/v1"

export type FeedbackCategory = "idea" | "problem" | "question" | "love"

export interface FeedbackResponse {
  ok: boolean
  delivery: "linear" | "email"
  thank_you: string
}

export async function submitFeedback(
  category: FeedbackCategory,
  message: string,
): Promise<FeedbackResponse> {
  const response = await fetch(`${API_BASE}/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ category, message }),
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const messageText = Array.isArray(data.errors) ? data.errors[0] : "Could not send feedback"
    throw new Error(messageText)
  }
  return data as FeedbackResponse
}
